import { Socials } from '@hg/stylizator/components'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

export interface IAttributes extends React.ComponentProps<typeof Socials> {}

const PromoBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes
  const subtitle = typeof attributes.subtitle === 'string' ? parse(attributes.subtitle) : attributes.subtitle

  return (
    <Socials
      title={attributes.title}
      subtitle={subtitle}
      background={attributes.background ?? 'white'}
      socials={attributes.socials ?? []}
    />
  )
}

export default PromoBlock
